import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NgxCsvParser, NgxCSVParserError } from 'ngx-csv-parser';
import { GlobalSelectionControlService } from 'src/app/map/services/global-selection-control.service';
import { ObstacleCSVContent, ObstacleCsvModel } from 'src/app/models/Obstacle';
import { ImportFormat } from 'src/app/models/importFormat';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { ObstacleDataService } from 'src/app/services/obstacle-data.service';

@Component({
  selector: 'app-obstacle-data-csv',
  templateUrl: './obstacle-data-csv.component.html',
  styleUrls: ['../../../../app.component.scss'],
  standalone: false
})
export class ObstacleDataCsvComponent implements OnInit {

  public obstacleImportCSVModel = new ObstacleCsvModel();

  importFormat: ImportFormat = ImportFormat.OBSTACLE_DATA_FORMATS;

  constructor(
    private modalService: ModalControlService,
    public bsModalRef: BsModalRef,
    private ngxCsvParser: NgxCsvParser,
    private obstacleDataService: ObstacleDataService,
    private globalSelectionService: GlobalSelectionControlService
  ) {
    this.obstacleImportCSVModel = new ObstacleCsvModel();
  }

  ngOnInit(): void {
    this.obstacleImportCSVModel.fillTable();
  }

  cancelObstacleDataImport(): void {
    this.bsModalRef.hide();
  }

  saveFile(event: any): void {
    this.obstacleImportCSVModel.file = event.target.files[0];
  }

  startImport(): void {
    if (this.obstacleImportCSVModel.file == null) {
      this.modalService.showMesssageModal("Error", "You have to choose a file before import it.");
      return;
    }
    if (!this.ngxCsvParser.isCSVFile(this.obstacleImportCSVModel.file)) {
      this.modalService.showMesssageModal("Error", 'The inserted file has an invalid extension. Insert a "csv" file.');
      return;
    }
    if (this.obstacleImportCSVModel.decimalSeparator == this.obstacleImportCSVModel.fieldSeparator) {
      this.modalService.showMesssageModal("Error", 'Please define a different field and decimal separator.');
      return;
    }
    this.ngxCsvParser
      .parse(this.obstacleImportCSVModel.file, { header: false, delimiter: this.obstacleImportCSVModel.fieldSeparator })
      .subscribe((result: Array<any>) => {
        for (var i = this.obstacleImportCSVModel.dataStartingLine - 1; i < result.length; i++) {
          if (result[i].length == 4 || result[i].length == 5) {
            // The system was able to parse successfully the CSV file.
            this.obstacleImportCSVModel.fileContent.push(ObstacleCSVContent.map(result[i], this.obstacleImportCSVModel.table));
          }
        }
        const currentTimeInMilliseconds = Date.now(); // unix timestamp in milliseconds
        this.obstacleImportCSVModel.fileName = this.obstacleImportCSVModel.file.name.slice(0, -4);
        this.obstacleImportCSVModel.layerName = this.obstacleImportCSVModel.fileName + "/" + currentTimeInMilliseconds;
        this.obstacleDataService.createObstaclesFromModel(this.obstacleImportCSVModel);
        this.activateStaticLayer();
      }, (error: NgxCSVParserError) => {
        this.modalService.showMesssageModal("Error", "Unable to extract information in CSV.");
      },
        () => {
          this.bsModalRef.hide();
        });

    this.bsModalRef.hide();
  }

  private activateStaticLayer() {
    this.globalSelectionService.staticLayers.active = true;
    this.globalSelectionService.staticLayers.childLayers?.forEach(el => {
      if (el.obstacleFileName != null) {
        el.showAll();
      }
    });
  }



}
